import { routes } from "../../../../router/routes";
import styles from "./NewHeader.module.scss";

import LogoImage from "./logo.svg";
import PhoneIcon from "./phoneIcon.svg";
import BurgerIcon from "./burger.svg";
import CloseIcon from "./close.svg";
import { useState } from "react";

const NewHeader = () => {
  const [active, setActive] = useState(false);

  return (
    <div className={styles.header}>
      <div className={styles.logo}>
        <img
          src={LogoImage}
          alt="На главную"
          onClick={() => (window.location.href = routes.homePage)}
        />
      </div>

      <img
        src={BurgerIcon}
        alt="Открыть меню"
        onClick={() => setActive(!active)}
        className={styles.burgerBtn}
      />

      <div
        className={
          active ? styles.burgerNav + " " + styles.active : styles.burgerNav
        }
      >
        <div className={styles.content}>
          <div className={styles.closeContainer}>
            <img
              src={CloseIcon}
              alt="Закрыть меню"
              className={styles.closeIcon}
              onClick={() => setActive(false)}
            />
          </div>

          <ul className={styles.btns}>
            <li
              className={styles.btn}
              onClick={() => (window.location.href = routes.directionsPage)}
            >
              Направления
            </li>
            <li
              className={styles.btn}
              onClick={() => (window.location.href = routes.tariffsPage)}
            >
              Тарифы
            </li>
            <li
              className={styles.btn}
              onClick={() => (window.location.href = routes.marketPage)}
            >
              Маркет
            </li>
            <li
              className={styles.btn}
              onClick={() => (window.location.href = routes.helpPage)}
            >
              Поддержка 24/7
            </li>
            <li className={styles.btnPhone}>
              <img src={PhoneIcon} alt="phone" className={styles.icon} />
              <a href="tel:79061006010" className={styles.text}>
                +7 906 100-60-10
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.controls}>
        <ul className={styles.btns}>
          <li
            className={styles.btn}
            onClick={() => (window.location.href = routes.directionsPage)}
          >
            Направления
          </li>
          <li
            className={styles.btn}
            onClick={() => (window.location.href = routes.tariffsPage)}
          >
            Тарифы
          </li>
          <li
            className={styles.btn}
            onClick={() => (window.location.href = routes.marketPage)}
          >
            Маркет
          </li>
          <li
            className={styles.btn}
            onClick={() => (window.location.href = routes.helpPage)}
          >
            Поддержка 24/7
          </li>
          <li className={styles.btnPhone}>
            <img src={PhoneIcon} alt="phone" className={styles.icon} />
            <a href="tel:79061006010" className={styles.text}>
              +7 906 100-60-10
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NewHeader;
